/** Run an agent turn. Response format (JSON or SSE) is determined by the agent definition. */
export const agentRunSpec = {
    uri: '/agent/[agent]/run',
    method: 'POST',
    adminOnly: true,
    stream: true,
};
